// extracted by mini-css-extract-plugin
export var dividerLine = "_93-3";
export var itemImage = "_93-9";
export var lightDivider = "_93-4";
export var modalContent = "_93-5";
export var modalContentCompact = "_93-6";
export var productCard = "_93-a";
export var productImage = "_93-b";
export var productImageCompact = "_93-7";
export var productImagePlaceholder = "_93-c";
export var productImagePlaceholderCompact = "_93-8";
export var progressBarBackground = "_93-1";
export var progressBarContainer = "_93-0";
export var progressBarFill = "_93-2";